module.exports = __webpack_public_path__ + "img/renou.cdb9deba.png";